import type { DataSourceAbstract, FilterFormType } from '@lighthouse/core'
import { recTakeFilterVariable, resolveFilter, useAtomData } from '@lighthouse/shared'
import { useCallback, useMemo } from 'react'

import { pageStackOfBlockAtom } from '@/atoms/application/state'
import { useCurrentStackIdContext } from '@/contexts/PageContext'
import { useParseVariableWithSubscription } from '@/hooks/useParseVariable'

interface UseFilterPayload {
    filter: FilterFormType | undefined
    dataSourceList: DataSourceAbstract[]
}

export const useFilter = (payload: UseFilterPayload) => {
    const { filter, dataSourceList } = payload

    const filterVariables = useMemo(() => filter && recTakeFilterVariable(filter?.expression), [filter])
    const parseVariable2Field = useParseVariableWithSubscription(filterVariables)
    const stackId = useCurrentStackIdContext()
    const formState = useAtomData(
        pageStackOfBlockAtom,
        useCallback(s => s?.[stackId], [stackId])
    )
    const resolvedFilter = useMemo(() => {
        if (!filter) {
            return
        }
        return resolveFilter({
            filter,
            extraParams: {
                dataSourceList,
                pageStackFormState: formState,
                parseVariable2Field
            }
        })
    }, [dataSourceList, filter, formState, parseVariable2Field])
    return { resolvedFilter }
}
